import { apiClient } from "./apiclient";

export const getPriorities = (token) =>
  apiClient.get("/master/priorities", {
    headers: { Authorization: `Bearer ${token}` },
  });

// appliesTo: "TICKET" or "STORY"
export const getCategories = (token) =>
  apiClient.get("/master/categories", {
    headers: { Authorization: `Bearer ${token}` },
  });